import React from 'react';
import { useHistory, useLocation } from 'react-router';
import {
  CUSTOMER_SERVICE_PAGE,
  HOME
} from '../config/navigationalRoutes';
import PrivacyPage from '../pages/PrivacyPage';
import TermsAndConditionsPage from '../pages/TermsAndConditionsPage';

const AuthPortalFooterLinksPage = () => {
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  if (pathname.includes('condition')) {
    return <TermsAndConditionsPage />;
  }
  if (pathname.includes('privacy')) {
    return <PrivacyPage />;
  }
  if (pathname.includes('forgot_pwd') || pathname.includes("/help/customer")) {
    window.location.href = CUSTOMER_SERVICE_PAGE;
    return <></>;
  }
  history.push(HOME);
  return <></>;
};

export default AuthPortalFooterLinksPage;
